import { resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-10f18574")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Button = _resolveComponent("Button")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return _withDirectives((_openBlock(), _createBlock("div", null, [
    _createVNode(_component_Button, {
      icon: "pi pi-print",
      class: "p-mr-1 tooltipButton formBox p-button-sm p-button-rounded notRequired",
      onClick: _ctx.printSpecimenLabel
    }, null, 8, ["onClick"])
  ], 512)), [
    [
      _directive_tooltip,
      _ctx.$t('form.printSpecimenLabel'),
      void 0,
      { right: true }
    ]
  ])
})